
import {userMixin} from "@/mixins/userMixin";

export default {
  name: 'LeftMenu',
  props: {
    miniVariant: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [
    userMixin
  ],
  data() {
    return {
      clipped: true,
      drawer: false,
      elementsWithDivider: ['New sale', 'Services', 'Orders', 'Register', 'Reports', 'Configuration', 'CMS'],
      isTabletClient: false,
      isOpen: false,
    }
  },
  computed: {
    minimize: {
      get() {
        return this.miniVariant
      },
      set(value) {
        this.$emit('variantChanged', value)
      },
    },
    isTablet() {
      return this.isTabletClient;
    },
    menuItems() {
      return this.allowViewingPrices
        ? this.$auth.user.menuItems
        : this.$auth.user.menuItems.filter((item) => item.text !== 'Register')
    },
  },
  mounted() {
    if (process.client) {
      this.checkTablet();
      window.addEventListener('resize', this.checkTablet);
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener('resize', this.checkTablet);
    }
  },
  methods: {
    checkTablet() {
      this.isTabletClient = window.innerWidth <= 1300;
    },
    }
}
